// extracted by mini-css-extract-plugin
export default {"toggle-container":"Toggle_toggle-container__U4Wa2","toggle-wrapper":"Toggle_toggle-wrapper__nRgzs","toggle-slider":"Toggle_toggle-slider__HY-Kv","checked":"Toggle_checked__uSAdY"};